import { Role } from '@/common/types_and_interfaces.ts'
import { Button } from '@/app/common/components/button/Button'
import AppDialog from '@/common/components/Dialog.tsx'
import { PulsingEllipsesLoader } from '@/common/components/PulsingEllipsesLoader.tsx'
import { useAppAlert } from '@/layouts/AppAlertProvider.tsx'
import { UpdateRole } from '@/queries/roles/roles.ts'
import { SyntheticEvent, useEffect, useState } from 'react'

interface EditRoleProps {
  role: Role | null
  close: () => void
  refreshPage: () => void
}
export default function EditRoleView({
  role,
  close,
  refreshPage,
}: EditRoleProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [description, setDescription] = useState<string>('')

  const { fireAlert } = useAppAlert()

  useEffect(() => {
    if (role) {
      setDescription(role.description)
    }
  }, [role])

  const handleSubmit = async (event: SyntheticEvent) => {
    if (!role) return
    event.preventDefault()
    setIsLoading(true)
    await UpdateRole({ description }, role!.id)
    setIsLoading(false)

    refreshPage()

    await fireAlert({
      variant: 'success',
      message: 'Role updated successfully.',
    })
    close()
  }

  return (
    <>
      <AppDialog open={role != null} setOpen={() => {}}>
        <AppDialog.Title>{role?.name} Role</AppDialog.Title>
        <div className="flex flex-col mt-6">
          <form
            id="invite_applicant_form"
            noValidate
            className="space-y-3"
            onSubmit={handleSubmit}
          >
            <div>
              <label
                htmlFor="firstname"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Description
              </label>
              <div className="mt-1">
                <textarea
                  id="description"
                  name="description"
                  rows={4}
                  className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                  value={description}
                  placeholder={'Enter description'}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </form>
          <div className="mt-8 flex items-center justify-end gap-x-2">
            <Button
              variant="outline"
              onClick={() => {
                close()
              }}
              type="reset"
              className="h-9 w-32"
            >
              Cancel
            </Button>
            <Button
              form="invite_applicant_form"
              type="submit"
              className="h-9 w-32 disabled:hover:bg-primary disabled:opacity-70"
              disabled={isLoading}
            >
              {isLoading ? (
                <PulsingEllipsesLoader size="md" color="white" />
              ) : (
                'Submit'
              )}
            </Button>
          </div>
        </div>
      </AppDialog>
    </>
  )
}
